// translation.ts
import { Change, nothingHere } from "@adornis/base/change.js";
import { logger } from "@adornis/base/logging.js";
var isTranslationDict = (value) => typeof value === "object" && !!value;
var Translator = class {
  constructor(options) {
    this._options = options;
    this.selectLanguage = this._options.selectLanguage;
  }
  /**
   * Translate a key with the contained dictionary.
   *
   * _Note: if you updated the dictionary with the `updateDictionary` function after instantiation, the new dictionary will NOT be used for autocompletion_
   */
  translate(keyA, keyB, keyC, keyD, keyE, keyF, keyG) {
    const pathArray = [keyA, keyB, keyC, keyD, keyE, keyF, keyG].filter((x) => !!x);
    const currLanguage = this._options.getSelectedLanguage();
    const currentLanguageIndex = Math.max(this._options.languages.indexOf(currLanguage), 0);
    const resolvedTranslationValue = Change.resolvePath(this._options.dictionary, [...pathArray]);
    if (resolvedTranslationValue === nothingHere) {
      logger.warn(`Translation could not resolve path ${pathArray.toString()}, rendering dot-joined path instead.`);
      return pathArray.join(".");
    }
    const selectEntryFromTranslationArray = (translationArray) => {
      const translation = translationArray[currentLanguageIndex];
      if (!translation) {
        logger.warn(
          `Translation did resolve path ${pathArray.toString()}, but did not find truthy value at array index ${currentLanguageIndex}. Rendering dot-joined path instead.`
        );
        return pathArray.join(".");
      }
      return translation;
    };
    if (Array.isArray(resolvedTranslationValue)) {
      return selectEntryFromTranslationArray(resolvedTranslationValue);
    }
    if (isTranslationDict(resolvedTranslationValue)) {
      if (Array.isArray(resolvedTranslationValue._root))
        return selectEntryFromTranslationArray(resolvedTranslationValue._root);
      if (typeof resolvedTranslationValue._root === "string")
        return resolvedTranslationValue._root;
      logger.warn(
        `Translation did resolve path ${pathArray.toString()}, but did find an object without _root key. Rendering dot-joined path instead.`
      );
      return pathArray.join(".");
    }
    return resolvedTranslationValue;
  }
  /**
   * Update the contained dictionary and languages array.
   *
   * **New or deleted keys will NOT be available in the translation functions autocompletion**
   */
  updateDictionary(dictionary, languages) {
    this._options.dictionary = dictionary;
    if (languages)
      this._options.languages = languages;
    this._options.onDictionaryUpdate?.();
  }
  /**
   * Like `updateDictionary`, but performs a deep merge on the contained dictionary and the new one.
   *
   * **New or deleted keys will NOT be available in the translation functions autocompletion**
   */
  mergeDictionary(dictionary) {
    this._options.dictionary = Change.deepMerge(this._options.dictionary, dictionary);
    this._options.onDictionaryUpdate?.();
  }
};
export {
  Translator
};
